import OperationLayout from '@/layout/OperatLayout'
import ControlLayout from '@/layout/ControlLayout'
const routes = [
  {
    path: '/',
    redirect: '/controlPlatform'
  },
  // 操作台
  {
    path: '/operatingPlatform',
    name: 'OperationLayout',
    meta: { title: '操作台布局' },
    component: OperationLayout,
    redirect: '/operatingPlatform/marker',
    children: [
      {
        path: 'marker',
        name: 'Marker',
        meta: { title: '图层管理', shareKey: 'marker', enableTemplate: true },
        component: () => import('@/views/operatingPlatform/Marker')
      },
      {
        path: 'mapStyle',
        name: 'MapStyle',
        meta: { title: '地图样式' },
        component: () => import('@/views/operatingPlatform/MapStyle')
      },
      {
        path: 'viewer',
        name: 'Viewer',
        meta: { title: '视点管理', shareKey: 'viewpoint', enableTemplate: true },
        component: () => import('@/views/operatingPlatform/Viewer')
      },
      {
        path: 'route',
        name: 'route',
        meta: { title: '路径规划', shareKey: 'path', enableTemplate: true },
        component: () => import('@/views/operatingPlatform/Route')
      }
      // {
      //   path: 'operatingPlatform',
      //   name: 'OperatingPlatform',
      //   meta: { title: '操作平台' },
      //   component: () => import('@/views/operatingPlatform/OperatingPlatform.vue')
      // }
    ]
  },
  // 控制台
  {
    path: '/controlPlatform',
    name: 'ControlLayout',
    meta: { title: '控制台布局' },
    component: ControlLayout,
    redirect: '/controlPlatform/mapManagement',
    children: [
      {
        path: 'mapManagement',
        name: 'MapManagement',
        meta: { title: '地图管理' },
        component: () => import('@/views/controlPlatform/MapManagement')
      },
      {
        path: 'tile',
        name: 'Tile',
        meta: { title: '模型管理' },
        component: () => import('@/views/controlPlatform/Tile')
      },
      {
        path: 'region',
        name: 'Region',
        meta: { title: '区域管理' },
        component: () => import('@/views/controlPlatform/Region')
      },
      // {
      //   path: 'demandManagement',
      //   name: 'DemandManagement',
      //   meta: { title: '需求管理' },
      //   component: () => import('@/views/controlPlatform/DemandManagement')
      // },
      {
        path: 'dataManagement',
        name: 'DataManagement',
        meta: { title: '数据管理' },
        component: () => import('@/views/controlPlatform/DataManagement')
      },
      {
        path: 'canvasManagement',
        name: 'CanvasManagement',
        meta: { title: '画布管理' },
        component: () => import('@/views/controlPlatform/CanvasManagement')
      },
      {
        path: 'EventTable',
        name: 'EventTable',
        hidden: true,
        meta: { title: '数据成果' },
        component: () => import('@/views/controlPlatform/EventTable')
      },
      {
        path: 'dictManagement',
        name: 'DictManagement',
        hidden: true,
        meta: { title: '字典管理', level: 2 },
        component: () => import('@/views/controlPlatform/SystemManagement/DictManagement')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: '用户登录' },
    component: () => import('@/views/login')
  },
  // 系统首页
  {
    path: '/home',
    name: 'Home',
    meta: { title: '首页' },
    component: () => import('@/views/home')
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    meta: { title: '个人中心' },
    component: () => import('@/views/userCenter')
  },
  {
    path: '/teamManagement',
    name: 'teamManagement',
    meta: { title: '团队管理' },
    component: () => import('@/views/teamManagement')
  },
  {
    path: '/joinTeam/:id',
    name: 'joinTeam',
    meta: { title: '加入团队' },
    component: () => import('@/views/joinTeam')
  },
  {
    path: '/payManagement',
    name: 'payManagement',
    meta: { title: '支付管理' },
    component: () => import('@/views/payManagement')
  },
  {
    path: '/share/:id',
    name: 'Share',
    meta: { title: '分享' },
    component: () => import('@/views/share')
  },
  {
    path: '/template/:id',
    name: 'Template',
    meta: { title: '模板分享' },
    component: () => import('@/views/templateShare')
  },
  {
    path: '/mapComponent',
    name: 'MapComponent',
    meta: { title: '地图' },
    component: () => import('@/views/mapComponent')
  },
  {
    path: '/elementTheme',
    name: 'ElementTheme',
    component: () => import('@/views/elementTheme/ElementTheme.vue')
  },
  {
    path: '/canvasShare/:id',
    name: 'CanvasShare',
    component: () => import('@/views/canvasShare')
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import('@/views/mobile')
  },
  // 404
  {
    path: '*',
    name: 'Error',
    meta: { title: '页面找不到了' },
    hidden: true,
    component: () => import('@/views/error/Error.vue')
  }
]

export default routes
